import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {EntityGraphResponse} from "../../../model/entity-graph";

export const entityGraphSelector = () => createSelector(
  [getUseQueryResultData<EntityGraphResponse>],
  (data) => {
    return data
  }
);
